import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import Heading from '../components/Heading'
import ModuleWithLoader from '../components/ModuleWithLoader'
import CancelHomeSecureSubscriptionForm from '../forms/CancelHomeSecureSubscriptionForm'
import globals from '../globals'
import HomeSecureAccountHistory from '../components/HomeSecureAccountHistory'
import AjaxLoader from '../components/AjaxLoader'

const HomeSecureManageSubscription = (props) => {
    const history = useHistory()
    const [isLoading, setIsLoading] = useState(false)

    const Subscribed = (
        <React.Fragment>
            <p className='m-0 mb-2 bold font-large'>Cancel your subscription</p>
            <p className='m-0 lh'>You can cancel your Home Secure subscription here. When you do, you’ll have access to Home Secure until the end of your current billing cycle. If you want to turn-off threat protection, safe search and parental control before your subscription ends, you can do so in the relevant Manage my service tab.</p>
        </React.Fragment>
    )

    const Trial = (
        <React.Fragment>
            <p className='m-0 mb-2 bold font-large'>Cancel your free trial</p>
            <p className='m-0 lh'>You can immediately cancel your Home Secure free trial here. If you cancel your free trial your internet service will be unprotected against cyberthreats such as malware, viruses and phishing sites that seek to steal your personal data. Your free trial offer will also expire. You can however subscribe to Home Secure, should you change your mind, for just $6/mth.</p>
        </React.Fragment>
    )

    const handleSuccess = () => {
        globals.pushEvent('CancelledHSSubscription')
        setIsLoading(true)
        setTimeout(() => history.push('/dashboard'), 500)
    }

    return (
        <div className='module overflow-visible manage-hs-subscription'>
            <Heading title='Cancel Home Secure' />
            <ModuleWithLoader isLoaded hasError={false} className='p-4'>
                <div className='row mb-5'>
                    <div className='col-12 col-md-8 offset-md-2 text-center mb-4'>
                        {props.serviceDetails.isSubscribed ? Subscribed : Trial}
                    </div>
                    <div className='col-12 d-flex align-items-center justify-content-center'>
                        {isLoading
                            ? <AjaxLoader />
                            : <CancelHomeSecureSubscriptionForm
                                    serviceId={props.serviceId}
                                    subscriptionEnds={props.serviceDetails.subscriptionEnds}
                                    isCancelled={props.serviceDetails.isCancelled}
                                    isTrial={props.serviceDetails.isTrial}
                                    handleSuccess={handleSuccess}
                              />}
                    </div>
                </div>
                <HomeSecureAccountHistory serviceId={props.serviceId} />
            </ModuleWithLoader>
        </div>
    )
}

HomeSecureManageSubscription.propTypes = {
    serviceId: PropTypes.number.isRequired,
    serviceDetails: PropTypes.object.isRequired
}

export default HomeSecureManageSubscription



// WEBPACK FOOTER //
// ./resources/js/modules/HomeSecureManageSubscription.js